import { useState } from "react";
import Overview from "./overview";
import Account from "./account";
import Manage from "./manage";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function SettingsPage() {
  return (
    <div className="w-full">
      <Tabs defaultValue="account" className="w-full">
        <TabsList className="mb-6">
{/*          <TabsTrigger value="overview">Overview</TabsTrigger>*/}
          <TabsTrigger value="account">Account</TabsTrigger>
          <TabsTrigger value="manage">Manage</TabsTrigger>
        </TabsList>

{/*        <TabsContent value="overview" className="mt-0">
          <Overview />
        </TabsContent>*/}

        <TabsContent value="account" className="mt-0">
          <Account />
        </TabsContent>

        <TabsContent value="manage" className="mt-0">
          <Manage />
        </TabsContent>
      </Tabs>
    </div>
  );
}